import { mapCollection } from '../../utils/collection.utils';
import { UniqueReport } from '../unique-report';

export class UniqueReportBuilder {
  static fromJson(json) {
    return (json)
      ? new UniqueReport(
        json.answerAVG,
        json.categoryTitle
      )
      : null;
  }

  static fromList(list) {
    return (Array.isArray(list)) ? mapCollection(UniqueReportBuilder.fromJson, list) : [];
  }
}
